import { useState, useEffect } from "react";
import { FormContentCred, FormContainerCredenciais, HeaderCredencial, ContentInfo } from "./styled"
import { Form, Input, Checkbox, DatePicker, ConfigProvider, Space, Flex, Button, Upload, Select, Collapse, Skeleton } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import dayjs from 'dayjs';
import { FileOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons"
import Stack from '@mui/material/Stack';
import listTables from "./tableTitles.json"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ModalAddCredencial from "./ModalAdicionar";
import ModalEditarCredencial from "./ModalEditar";
import ModalRemoverCredencial from "./ModalRemover";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import {Box, Pagination} from "@mui/material";

import { CiExport, CiImport } from "react-icons/ci";
import { formatCPF } from "../../../../../../../function/utilis/function";
import TabelaCredenciais from "./TabelaCredenciais";
import { Method_POST_REST } from "../../../../../../../service/api";


export function CredenciaisAcesso({clienteId}) {
    console.log("Dentro do componente, clienteId:", clienteId);
    const [isProcuracaoVisible, setIsProcuracaoVisible] = useState(false);
    const [isCertificadoVisible, setIsCertificadoVisible] = useState(false);
    const [loadings, setLoadings] = useState([]);
    const [isTable, setIsTable] = useState(false);
    const [titleTable, setTitleTable] = useState(listTables);
    const [isModalAddVisible, setIsModalAddVisible] = useState(false);
    const [isModalEditVisible, setIsModalEditVisible] = useState(false);
    const [isModalRemoveVisible, setIsModalRemoveVisible] = useState(false);
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [isCredenciaisAdicionais, setIsCredenciaisAdicinais] = useState([]);
    const [idCredencialAdicional, setIdCredenciadlAdicional] = useState(null);
    const [fileName, setFileName] = useState("");
    const dateFormat = 'YYYY-MM-DD';
    const [atualDate, setAtualDate] = useState(dayjs().format(dateFormat));
    const [isUploadVisible, setIsUploadVisible] = useState(false);

    const [page, setPage] = useState(1);
    const itemsPerPage = 5;

    const [formulario, setFormulario] = useState({
        procuracaoDigital: "",
        dataInicioProcuracaoDigital: "",
        dataTerminoProcuracaoDigital: "",
        certificadoCedido: false,
        certificadoModalidade: "",
        certificadoTipo: "",
        certificadoSenha: "",
        certificadoDataExpiracao: "",
        acessoRemoto: false,
        codigoAcessoSN: "",
        cpfAcessoSN: "",
        codigoAcessoMun: "",
        senhaAcessoMun: "",
        cadastroContadorNFSe: "",
        codigoAcessoEst: "",
        senhaAcessoEst: "",
        codigoAcessoEmpregWeb: "",
        senhaAcessoEmpregWeb: "",
    });

    useEffect(() => {
        let height = document.documentElement.scrollHeight;
        window.parent.postMessage({ frameHeight: height }, "*");
      },);

    useEffect(() => {
      if(!clienteId) return;

      //aplicar service aqui também
      const fetchData = async () => {
          const url = "/portal/rest/cliente/empresa/credencial-acesso/consultar";
          const param = {
              empresa: {
                  id: Number(clienteId)
              }
          }

          setIsLoadingForm(true);
          try {
              const response = await axios.post(url, param, { withCredentials: true });

              setFormulario(prevState => ({
                  ...prevState,
                  procuracaoDigital: response.data.procuracaoDigital,
                  dataInicioProcuracaoDigital: response.data.dataInicioProcuracaoDigital,
                  dataTerminoProcuracaoDigital: response.data.dataTerminoProcuracaoDigital,
                  certificadoCedido: response.data.certificadoCedido,
                  certificadoDataExpiracao: response.data.certificadoDataExpiracao,
                  certificadoModalidade: response.data.certificadoModalidade,
                  certificadoSenha: response.data.certificadoSenha,
                  certificadoTipo: response.data.certificadoTipo,
                  codigoAcessoSN: response.data.codigoAcessoSN,
                  cpfAcessoSN: response.data.cpfAcessoSN,
                  codigoAcessoMun: response.data.codigoAcessoNFSe,
                  senhaAcessoMun: response.data.codigoAcessoNFSe,
                  cadastroContadorNFSe: response.data.cadastroContadorNFSe,
                  codigoAcessoEst: response.data.codigoAcessoNFe,
                  senhaAcessoEst: response.data.senhaAcessoNFSe,
                  codigoAcessoEmpregWeb: response.data.codigoAcessoEW,
                  senhaAcessoEmpregWeb: response.data.senhaAcessoEW,
                  acessoRemoto: response.data.acessoContador
              }));

              if (response.data.certificadoCedido === true) {
                  setIsCertificadoVisible(true);
              }

              if (response.data.credenciaisAdicionais.length > 0 || response.data.credenciaisAdicionais != []) {
                  setIsCredenciaisAdicinais(response.data.credenciaisAdicionais);
                  setIsTable(true);
              } else {
                  setIsCredenciaisAdicinais([]);
                  setIsTable(false);
              }
          } catch (error) {
              toast.error("credenciais inválidas", error)
          } finally {
              setIsLoadingForm(false);
          }
      }
      fetchData();
    }, [clienteId]);

    useEffect(() => {
        setAtualDate(dayjs().format(dateFormat));
        console.log(atualDate);
        console.log(formulario.dataInicioProcuracaoDigital);
    });

    /*useEffect(()=> {
      console.log("formulario:", formulario);
    })*/

    const postData = async () => {
        const url = "/portal/rest/cliente/empresa/credencial-acesso/atualizar";
        const param = {
            empresa: {
                id: clienteId
            },
            acessoContador: formulario.acessoRemoto,
            cadastroContadorNFSe: formulario.cadastroContadorNFSe,
            certificadoCedido: formulario.certificadoCedido,
            certificadoDataExpiracao: formulario.certificadoDataExpiracao,
            certificadoModalidade: formulario.certificadoModalidade,
            certificadoSenha: formulario.certificadoSenha,
            certificadoTipo: formulario.certificadoTipo,
            codigoAcessoECAC: "",
            codigoAcessoEW: formulario.codigoAcessoEmpregWeb,
            codigoAcessoNFSe: formulario.codigoAcessoMun,
            codigoAcessoNFe: formulario.codigoAcessoEst,
            codigoAcessoSN: formulario.codigoAcessoSN,
            cpfAcessoSN: formulario.cpfAcessoSN,
            dataInicioProcuracaoDigital: formulario.dataInicioProcuracaoDigital,
            dataTerminoProcuracaoDigital: formulario.dataTerminoProcuracaoDigital,
            procuracaoDigital: formulario.procuracaoDigital,
            senhaAcessoNFSe: formulario.senhaAcessoMun,
            senhaAcessoNFe: formulario.senhaAcessoEst,
            senhaAcessoEW: formulario.senhaAcessoEmpregWeb,
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            toast.success("Dados atualizados com sucesso!");
        } catch (error) {
            toast.error("falha no envio", error)
        } finally {
            setLoadings(false);
        }
    }

    const adicionarCredencial = (novaCredencial) => {
        setIsCredenciaisAdicinais(novaCredencial);
    };

    const procuracaoChange = (e) => {
        setFormulario({
            ...formulario,
            procuracaoDigital: e.target.checked
        });
        setIsProcuracaoVisible(e.target.checked);
    };

    const handleModalEditar = (idCredencial) => {
        setIsModalEditVisible(true);
        setIdCredenciadlAdicional(idCredencial);
    }

    const handleModalRemover = (idCredencial) => {
        setIsModalRemoveVisible(true);
        setIdCredenciadlAdicional(idCredencial);
    }

    const props = {
        name: 'certificado-digital',
        multiple: true,
        customRequest: async ({ file, onSuccess, onError }) => {
            try {
                const formData = new FormData();
                formData.append('file', file);

                const response = await axios.post(`/portal/rest/cliente/empresa/credencial-acesso/certificado/arquivo/upload`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (response.data.erro) {
                    const errorMessage = response.data.erro.mensagem;
                    toast.error(`Erro: ${errorMessage}`);
                    onError(new Error(errorMessage));
                } else {
                    onSuccess(response.data, file);
                    setFileName(file.name);
                }
            } catch (error) {
                toast.error(`${file.name} falha ao enviar o arquivo.`);
                onError(error);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    const handleDownload = async () => {
        const documento = fileName;

        //const filenameWithoutPath = documento.substring(documento.lastIndexOf('\\') + 1);
        //const fileNameFormated = filenameWithoutPath.replace(/-(\d{2})(\d{4})\.pdf$/, ' $1 $2.pdf');
        const fileNameFormated = documento.split('\\').pop().split('/').pop()

        const url = `/portal/rest/cliente/empresa/credencial-acesso/certificado/arquivo/download?filename=${fileNameFormated}`;

        // setExporting(true);
        try {
            const response = await axios.get(url, {
                responseType: 'blob',
                withCredentials: true,
            });

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(blobUrl);
            link.parentNode.removeChild(link);
           
        } catch (error) {
            toast.error("Não foi possível fazer o download do arquivo", error);
            // setExporting(false);
        } finally {
            // setExporting(false);
        }

    }

    const handleChange = (event, value) => {
        setPage(value);
    };

    const paginatedData = isCredenciaisAdicionais.slice(
      (page - 1) * itemsPerPage,
      page * itemsPerPage
    );

    const atualizarTelaCredenciais = async (idClient) => {
      const url = "/cliente/empresa/credencial-acesso/consultar";
      const param = { empresa: { id: idClient } };

      try {
        const data = await Method_POST_REST(url, param);
        adicionarCredencial(data.credenciaisAdicionais);
      } catch (error) {
        console.error("Erro ao remover credencial:", error.message);
      } finally {
        setLoadings(false);
      }
    };
  

    return (
      <>
        {isLoadingForm ? (
          <>
            {[...Array(3)].map((_, index) => (
              <Skeleton
                active
                key={index}
                variant="rectangular"
                width="100%"
                height={8}
                style={{ padding: "5px 20px" }}
              />
            ))}
          </>
        ) : (
          <FormContainerCredenciais>
            <HeaderCredencial>
              <div className="title-header">
                <h2>Credencial de Acesso</h2>
                <h3>
                  {" "}
                  Mantenha atualizadas as credenciais de acesso de sua empresa
                  aos serviços públicos.
                </h3>
              </div>
            </HeaderCredencial>

            <Collapse
              defaultActiveKey={["1"]}
              style={{ margin: "20px" }}
              items={[
                {
                  key: "1",
                  label: "Credenciais de acesso",
                  children: (
                    <ContentInfo>
                      <p>
                        {" "}
                        Escolha a forma com que o Meu Contador Online deverá
                        acessar as informações da minha empresa junto à Receita
                        Federal do Brasil:
                      </p>
                      <div className="form-content-checkbox">
                        <Form.Item className="form-item" name="procuracao">
                          <Checkbox
                            checked={formulario.procuracaoDigital}
                            onChange={procuracaoChange}
                          >
                            <strong>Procuração Digital</strong> (Recomendado,{" "}
                            <a href="https://www.meucontadoronline.com.br/blog/procuracao-receita-federal/">
                              clique aqui
                            </a>{" "}
                            e veja como)
                          </Checkbox>
                        </Form.Item>
                        {formulario.procuracaoDigital && (
                          <>
                            <Form.Item
                              label="Data Início Vigência"
                              name="dateInit"
                            >
                              <Space direction="vertical">
                                <ConfigProvider locale={ptBR}>
                                  <DatePicker
                                    defaultValue={
                                      formulario.dataInicioProcuracaoDigital
                                        ? dayjs(
                                            formulario.dataInicioProcuracaoDigital,
                                            dateFormat
                                          )
                                        : dayjs(atualDate, dateFormat)
                                    }
                                    format="YYYY-MM-DD"
                                    onChange={(_, dateString) =>
                                      setFormulario({
                                        ...formulario,
                                        dataInicioProcuracaoDigital: dateString,
                                      })
                                    }
                                  />
                                </ConfigProvider>
                              </Space>
                            </Form.Item>
                            <Form.Item
                              label="Data Término Vigência"
                              name="dataTerm"
                            >
                              <Space direction="vertical">
                                <ConfigProvider locale={ptBR}>
                                  <DatePicker
                                    defaultValue={dayjs(
                                      formulario.dataTerminoProcuracaoDigital
                                    )}
                                    format="YYYY-MM-DD"
                                    onChange={(_, dateString) =>
                                      setFormulario({
                                        ...formulario,
                                        dataTerminoProcuracaoDigital:
                                          dateString,
                                      })
                                    }
                                  />
                                </ConfigProvider>
                              </Space>
                            </Form.Item>
                          </>
                        )}
                      </div>
                      <div className="form-content">
                        <p>
                          A forma mais segura e reconhecida pela Receita Federal
                          do Brasil para permitir o acesso do seu contador aos
                          dados da sua empresa é através da procuração digital.
                          Você pode revogar esse acesso a qualquer momento. Para
                          saber como gerar a procuração digital, siga o
                          passo-a-passo no site da Receita Federal. Se precisar
                          de ajuda, nossos analistas podem orientar sobre os
                          procedimentos e alternativas disponíveis.
                        </p>
                      </div>
                      <div className="form-content-checkbox">
                        <Form.Item className="form-item" name="certificadoD">
                          <Checkbox
                            checked={formulario.certificadoCedido}
                            onChange={(e) => {
                              setFormulario({
                                ...formulario,
                                certificadoCedido: e.target.checked,
                              });
                              setIsCertificadoVisible(e.target.checked);
                            }}
                          >
                            <strong>Certificado Digital</strong>
                          </Checkbox>
                        </Form.Item>
                      </div>
                      {isCertificadoVisible && (
                        <>
                          <div className="form-certificate">
                            <Form.Item
                              className="form-item"
                              label="Arquivos"
                              name="arquivos"
                            >
                              <p>
                                <FileOutlined />
                                Arquivo
                              </p>
                            </Form.Item>
                            <Form.Item>
                              <div className="btns-certificate">
                                <Flex gap="small" wrap>
                                  <Button
                                    className="btn-certificate"
                                    loading={loadings[0]}
                                    onClick={handleDownload}
                                  >
                                    <CiImport /> Baixar
                                  </Button>
                                </Flex>

                                <Flex gap="small" wrap>
                                  <Button
                                    onClick={() => setIsUploadVisible(true)}
                                    className="btn-certificate"
                                  >
                                    <CiExport /> Trocar
                                  </Button>
                                </Flex>
                              </div>
                            </Form.Item>
                          </div>
                          {isUploadVisible && (
                            <div className="form-certificate">
                              <Form.Item
                                className="form-item"
                                label="Carregue o arquivo do certificado digital de sua empresa:"
                                name="upload"
                              >
                                <Upload {...props}>
                                  <Button icon={<UploadOutlined />}>
                                    Adicionar documento
                                  </Button>
                                </Upload>
                              </Form.Item>
                            </div>
                          )}
                          <div className="form-certificate">
                            <div style={{ margin: 5 }}>
                              <label>Tipo de Certificado</label>
                              <Select
                                showSearch
                                placeholder="Selecione"
                                defaultValue={formulario.certificadoTipo}
                                style={{ width: "200px" }}
                                onChange={(value) =>
                                  setFormulario({
                                    ...formulario,
                                    certificadoTipo: value,
                                  })
                                }
                                options={[
                                  { value: "A1", label: "Tipo A1" },
                                  { value: "A2", label: "Tipo A3" },
                                ]}
                              />
                            </div>
                            <div style={{ margin: 5 }}>
                              <label>Modalidade do Certificado</label>
                              <Select
                                showSearch
                                placeholder="Selecione"
                                value={formulario.certificadoModalidade}
                                style={{ width: "250px" }}
                                onChange={(value) =>
                                  setFormulario({
                                    ...formulario,
                                    certificadoModalidade: value,
                                  })
                                }
                                options={[
                                  { value: "1", label: "e-CNPJ (preferível)" },
                                  { value: "eCNPJ", label: "e-CNPJ" },
                                ]}
                              />
                            </div>
                            <div style={{ margin: 5 }}>
                              <label>Senha do Certificado</label>
                              <Input
                                defaultValue={formulario.certificadoSenha}
                                placeholder="Digite a senha"
                                onChange={(e) =>
                                  setFormulario({
                                    ...formulario,
                                    certificadoSenha: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div style={{ margin: 5 }}>
                              <label>Data Expiração do Certificado</label>
                              <Space direction="vertical">
                                <ConfigProvider locale={ptBR}>
                                  <DatePicker
                                    defaultValue={
                                      formulario.certificadoDataExpiracao
                                        ? dayjs(
                                            formulario.certificadoDataExpiracao
                                          )
                                        : dayjs(atualDate, dateFormat)
                                    }
                                    format="YYYY-MM-DD"
                                    onChange={(_, dateString) =>
                                      setFormulario({
                                        ...formulario,
                                        certificadoDataExpiracao: dateString,
                                      })
                                    }
                                  />
                                </ConfigProvider>
                              </Space>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="form-content">
                        <p>
                          {" "}
                          O Certificado Digital garante a identidade,
                          autenticidade e validade jurídica de sua empresa em
                          documentos e declarações. O certificado digital é
                          exigido por empresas para emissão de Notas Fiscais
                          eletrônicas, exceto no caso de MEIs. Para adquirir ou
                          renovar um certificado digital,{" "}
                          <a href="https://serasa.certificadodigital.com.br/">
                            clique aqui
                          </a>
                          .
                        </p>
                      </div>
                      <div className="form-content-checkbox">
                        <Form.Item className="form-item" name="acessoRemoto">
                          <Checkbox
                            checked={formulario.acessoRemoto}
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                acessoRemoto: e.target.checked,
                              })
                            }
                          >
                            <strong>Acesso Remoto</strong>
                          </Checkbox>
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <p>
                          Conceder acesso remoto a uma máquina da minha empresa
                          com certificado digital instalado para o Meu Contador
                          Online me auxiliar a fazer a procuração na Receita
                          Federal do Brasil.
                        </p>
                      </div>
                    </ContentInfo>
                  ),
                },
              ]}
            />

            <Collapse
              style={{ margin: "20px" }}
              items={[
                {
                  key: "2",
                  label: "Acessos municipais",
                  children: (
                    <FormContentCred>
                      <div className="form-content-cred">
                        <div style={{ margin: 5 }}>
                          <label>Código Acesso SN</label>
                          <Input
                            value={formulario.codigoAcessoSN}
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                codigoAcessoSN: e.target.value,
                              })
                            }
                            placeholder="Digite o código"
                          />
                        </div>

                        <div style={{ margin: 5 }}>
                          <label>CPF de Acesso SN</label>
                          <Input
                            value={formatCPF(formulario.cpfAcessoSN || "")}
                            placeholder="Digite o CPF"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                cpfAcessoSN: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <p>
                        O Código de Acesso SN é a identificação de acesso
                        utilizada pela empresa optante do regime tributário
                        Simples Nacional junto ao Portal do Simples Nacional da
                        Receita Federal. Para acesso ao portal,{" "}
                        <a href="https://www8.receita.fazenda.gov.br/SimplesNacional/">
                          clique aqui
                        </a>
                        .
                      </p>
                      <div className="form-content-cred">
                        <div style={{ margin: 5 }}>
                          <span>Código Acesso Municipal</span>
                          <Input
                            value={formulario.codigoAcessoMun || ""}
                            placeholder="Digite o código"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                codigoAcessoMun: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div style={{ margin: 5 }}>
                          <span>Senha Acesso Municipal</span>
                          <Input.Password
                            value={formulario.senhaAcessoMun || ""}
                            placeholder="Digite a senha"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                senhaAcessoMun: e.target.value,
                              })
                            }
                          />
                        </div>

                        <Form.Item
                          className="form-item"
                          label="Procuração Municipal"
                          name="cadastroContador"
                        >
                          <Checkbox
                            checked={formulario.cadastroContadorNFSe || false}
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                cadastroContadorNFSe: e.target.checked,
                              })
                            }
                          >
                            <strong>Cadastro Contador</strong>
                          </Checkbox>
                        </Form.Item>
                      </div>
                      <div className="form-content-cred">
                        <div style={{ margin: 5 }}>
                          <label>Código Acesso Estadual</label>
                          <Input
                            value={formulario.codigoAcessoEst || ""}
                            placeholder="Digite o código"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                codigoAcessoEst: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div style={{ margin: 5 }}>
                          <label>Senha Acesso Estadual</label>
                          <Input.Password
                            value={formulario.senhaAcessoEst || ""}
                            placeholder="Digite a senha"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                senhaAcessoEst: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <p>
                        O Código de Acesso Estadual é a identificação e senha de
                        acesso utilizada pela empresa de comércio para emissão
                        de Nota Fiscal de Comércio eletrônica (NF-e) junto ao
                        Governo Estadual.
                      </p>
                      <div className="form-content-cred">
                        <div style={{ margin: 5 }}>
                          <label>Código Acesso Empregador Web</label>
                          <Input
                            value={formulario.codigoAcessoEmpregWeb || ""}
                            placeholder="Digite o código"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                codigoAcessoEmpregWeb: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div style={{ margin: 5 }}>
                          <label>Senha Acesso Empregador Web</label>
                          <Input.Password
                            value={formulario.senhaAcessoEmpregWeb || ""}
                            placeholder="Digite a senha"
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                senhaAcessoEmpregWeb: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <p>
                        O Código de Acesso do Empregador Web é a identificação e
                        senha de acesso utilizada pela empresa ao Portal do
                        Empregador Web da Ministério do Trabalho e Emprego. Para
                        acesso ao portal,{" "}
                        <a href="https://sd.maisemprego.mte.gov.br/sdweb/empregadorweb/login.jsf">
                          {" "}
                          clique aqui
                        </a>
                        .
                      </p>
                    </FormContentCred>
                  ),
                },
              ]}
            />

            <TabelaCredenciais
              setIsModalAddVisible={setIsModalAddVisible}
              isCredenciaisAdicionais={isCredenciaisAdicionais}
              paginatedData={paginatedData}
              handleModalEditar={handleModalEditar}
              handleModalRemover={handleModalRemover}
            />

            <Stack spacing={2} style={{ alignItems: "center" }}>
              <Pagination
                count={Math.ceil(isCredenciaisAdicionais.length / itemsPerPage)}
                page={page}
                onChange={handleChange}
              />
            </Stack>

            <br />

            <div
              style={{
                display: "flex",
                width: "100%",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <Button loading={loadings[0]} onClick={postData}>
                Salvar
              </Button>
            </div>

            {isModalAddVisible && (
              <div
                className={`ModalAdd ${
                  isModalAddVisible ? "active" : "inactive"
                }`}
              >
                <ModalAddCredencial
                  isOpen={isModalAddVisible}
                  atualizarTelaCredenciais={atualizarTelaCredenciais}
                  idClient={clienteId}
                  onClose={() => setIsModalAddVisible(false)}
                />
              </div>
            )}
            {isModalEditVisible && (
              <div
                className={`ModalEdit ${
                  isModalEditVisible ? "active" : "inactive"
                }`}
              >
                <ModalEditarCredencial
                  isOpen={isModalEditVisible}
                  idClient={clienteId}
                  credencialAdicionalId={idCredencialAdicional}
                  atualizarTelaCredenciais={atualizarTelaCredenciais}
                  onClose={() => setIsModalEditVisible(false)}
                />
              </div>
            )}
            {isModalRemoveVisible && (
              <div
                className={`ModalEdit ${
                  isModalRemoveVisible ? "active" : "inactive"
                }`}
              >
                <ModalRemoverCredencial
                  isOpen={isModalRemoveVisible}
                  idClient={clienteId}
                  credencialAdicionalId={idCredencialAdicional}
                  atualizarTelaCredenciais={atualizarTelaCredenciais}
                  onClose={() => setIsModalRemoveVisible(false)}
                />
              </div>
            )}
          </FormContainerCredenciais>
        )}
      </>
    );
}

export default CredenciaisAcesso;